export default __webpack_public_path__ + "static/media/677.eb60b5cc.gif";